/*
 * @Author: Teemo Ding
 * @Date: 2021-12-24 10:48:02
 * @LastEditTime: 2021-12-30 11:22:49
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/SubscriptionBuy/SubscriptionBuyEdit/FirstOrderGift/index.tsx
 */
import { Form } from 'antd';
import React from 'react';
//import { get } from 'lodash';
import { useI18n } from '@/src/hooks/useRouterChange';
import { i18nGet } from '@/src/tools/tools';
import { SectionWrapper } from 'src/components/Layouts';
import OrderGiftTable from '../../../Components/ProductsItems/OrderGiftTable';
import css from './css.module.less';

const FirstOrderGift = () => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <SectionWrapper
      title={getI18n(
        'subscriptionBuy.subscriptionBuy.subscriptionBuyEdit_FirstOrderGift_title',
      )}
      containerClassName={css.section}
      titleClassName={css.sectionTitle}>
      {/* <Form.Item
        noStyle
        shouldUpdate={(p, c) => {
          const cC = get(c, 'salesChannel.uuid');
          const pC = get(p, 'salesChannel.uuid');
          return cC !== pC;
        }}>
        {({ getFieldValue }: any) => ( */}
      <Form.Item name='firstOrderGifts' initialValue={[]} noStyle>
        <OrderGiftTable />
      </Form.Item>
      {/* )}
      </Form.Item> */}
    </SectionWrapper>
  );
};

export default FirstOrderGift;
